export default {
  day60: 'REMINDED_60_DAYS',
  day30: 'REMINDED_30_DAYS',
  day7: 'REMIND_7_DAYS',
  thankyou: 'THANK_YOU',
  tracking: 'TRACKING',
  eventConfirmation: 'EVENT_CONFIRMATION',
  notReminded: 'NOT_REMINDED',
  cancellation: 'CANCELLATION'
}



// WEBPACK FOOTER //
// ./src/store/constants/emailTemplateType.js